import type { DriveStep } from 'driver.js';
import { useAuthStore } from '@/store/authStore';
import { featuredCommunitiesPhrase, maxCommunitiesForPlan } from '@/types';

const at = (id: string) => `[data-tour="${id}"]`;

/** "Tour this page" for Communities (/studio/communities). Anchors live in CommunitiesPage.tsx. */
export function getCommunitiesTourSteps(plan: string | null = useAuthStore.getState().plan): DriveStep[] {
  // Same cap as the page's Featured Limit counter, so the tour never says 10 on a 25 plan.
  const cap = featuredCommunitiesPhrase(maxCommunitiesForPlan(plan));
  return [
    {
      popover: {
        title: 'Feature your communities',
        description:
          'Showcase the neighborhoods you serve, each with its own live MLS listings. Here’s how ' +
          'to find and feature them.',
      },
    },
    {
      element: at('communities-search'),
      popover: {
        title: 'Search by location',
        description:
          'Enter your state and county (and optionally a community name) to find real, MLS-backed ' +
          'communities in your area.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('communities-search-btn'),
      popover: {
        title: 'Run the search',
        description: 'Click to pull candidate communities from the MLS for your area.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('communities-results'),
      popover: {
        title: 'Pick your communities',
        description:
          `Results appear here. Choose the ones you want to feature (${cap}) — each will show ` +
          'its own live listings on your site.',
        side: 'top',
        align: 'center',
      },
    },
    {
      element: at('communities-featured'),
      popover: {
        title: 'Your featured list',
        description:
          'The communities you’ve chosen live here. Edit each one to add photos, a description, ' +
          'and local details — by hand or with AI help.',
        side: 'top',
        align: 'center',
      },
    },
  ];
}
